import type { ApolloClient } from "@apollo/client";

import type { EhrPatientContext } from "./elationPatientToContext";
import {
  RESOLVE_EHR_MEMBER,
  type EhrMemberMatch,
  type ResolveEhrMemberResult,
  type ResolveEhrMemberVars,
} from "../graphql/resolveEhrMember";

/** Seam for EHR patient -> Astrana member resolution. Inject a fake in tests. */
export interface EhrAdapter {
  resolveMembers(ctx: EhrPatientContext, options?: { includeInactive?: boolean }): Promise<EhrMemberMatch[]>;
}

export function createApolloEhrAdapter(client: ApolloClient<unknown>): EhrAdapter {
  return {
    async resolveMembers(ctx: EhrPatientContext, options?: { includeInactive?: boolean }): Promise<EhrMemberMatch[]> {
      if (!ctx.ehrPatientId) return [];
      const { data } = await client.query<ResolveEhrMemberResult, ResolveEhrMemberVars>({
        query: RESOLVE_EHR_MEMBER,
        variables: {
          sourceSystem: ctx.sourceSystem,
          sourceSystemId: ctx.ehrPatientId,
          includeInactive: options?.includeInactive ?? false,
        },
        fetchPolicy: "network-only",
      });
      return data?.resolveEhrMember ?? [];
    },
  };
}
